import React from "react";
import R14, {
  Text,
  DataTable,
  View,
  SafeAreaView,
  Image,
} from "../core";
import Touchable from "../components/TouchableComponent";
import NoRecordsFound from "./NoRecordsFound";
import CommonUtility from "../utils/CommonUtility";
import { commonStyles } from "../assets/css/commonStyle";
import { gridTableStyles } from "../assets/css/gridTableStyles";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { BILLER_STATUS, BLOCK_UNBLOCK } from "../constant/app.data.constant";
import BlockMenu from "./BlockMenu";
import StatusComponent from "./StatusComponent";

import removeFilterIcon from "../assets/images/NewRemoveFilterIcon.png";
export default R14.connect(
  class PAMGridTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.handleDeleteClientPress = this.handleDeleteClientPress.bind(this);
      this.handleAddClientPress = this.handleAddClientPress.bind(this);
      this.initializer = this.initializer.bind(this);
      this.pageLoader = this.pageLoader.bind(this);
      this.cellRenderer = this.cellRenderer.bind(this);
      this.rowKeyExtractor = this.rowKeyExtractor.bind(this);
    }

    async initializer(gridState) {
      this.props.app.dm.userSession.setState({isLoading: true});
      const data = await this.props.getPageData(gridState, { totalCount: true });
      this.props.app.dm.userSession.setState({isLoading: false});
      return data;
    }
    async pageLoader(gridState) {
      let res = await this.props.getPageData(gridState, { totalCount: true }, false);
      return res.pageData;
    }
    get dataTable() {
      return this.props.app.ui.dataTable("clients");
    }

    shortenText = (txt = "", limit = 30) => {
      if (!!txt && !isNaN(txt) && !Number.isInteger(+txt)) {
        const num = +txt;
        return num.toFixed(2);
      } else if (!!txt && txt.length > limit) {
        return txt.substring(0, limit) + '...';
      } else {
        return txt;
      }
    };

    getNestedProperty(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    renderPAMCellRenderer(e) {
      const { columns, columnName, row } = e;
      const { profileIcon, onProfileIcon } = this.props;
      let text = row[columnName];

      if (columns && columns[columnName] && columns[columnName].label === "Action") {
        const status = BLOCK_UNBLOCK[row.status];
        if (!status) return null;
        return <View style={[gridTableStyles.btnHeight]} key={`BlockMenu_$`}>
          <BlockMenu
            status={row.status}
            directory={true}
            biller={row}
            popupMenuStyle={responsiveTableStyle.popupMenuStyle}
            refreshDataTable={this.refreshDataTable}
          />
        </View>;
      }

      if (profileIcon === columnName) {
        if (columnName.includes(".")) text = this.getNestedProperty(row, columnName);
        return (
          <Touchable onPress={() => onProfileIcon(row)}>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
            <View style={[responsiveTableStyle.userIconDiv, commonStyles.flex1, commonStyles.justifyContentCenter, commonStyles.alignItemsCenter, commonStyles.marLT0, commonStyles.marT0, commonStyles.marB0, commonStyles.marginRight5]}>
              <Text
                style={[
                  commonStyles.fontWeight500,
                  commonFontStyles.workSans,
                  commonStyles.exSmallHeading,
                  commonStyles.userInitial,
                  commonStyles.contentColor,
                  responsiveTableStyle.userInitial,
                  commonStyles.dBlock
                ]}>
                {CommonUtility.shortName(`${text}`)}
              </Text>
            </View>
            <Text style={[commonFontStyles.workSans, gridTableStyles.cellText]}>{this.shortenText(text)} </Text>
          </View>
          </Touchable>
        )
      }

      return <View style={[responsiveTableStyle.td, responsiveTableStyle.billerDirectoryStatus, commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter]}>
        <View style={[gridTableStyles.statusCircle, responsiveTableStyle.borderColorblocked, responsiveTableStyle[`borderColor${text === "requested" ? "new" : text}`]]}></View>
        <Text
          style={[
            commonFontStyles.workSans,
            commonMetricsStyle.smallHeading,
            commonStyles.transformUpperCase,
            commonStyles.fontWeight400,
            commonStyles.exSmallHeading,
            commonStyles.contentColor,
            responsiveTableStyle.paddingTop3,
            commonStyles.dBlock
          ]}>
          {BILLER_STATUS[text]}
        </Text>
      </View>
    }

    cellRenderer(e) {
      return this.renderPAMCellRenderer(e)
    }
    rowKeyExtractor(row) {
      return row.uid;
    }

    async handleAddClientPress() {
      this.props.app.nav.to("addClientRoute", {
        mode: "add"
      })
    }

    async handleDeleteClientPress(uid) {
      this.props.app.ui.progressIndicator.show();
      this.props.app.ui.progressIndicator.hide({ timeout: 750 });
    }

    refreshDataTable = () => {
      this.dataTable.refresh();
      this.props.app.dm.userSession.setState({isLoading: true});
      return false;
    };

    onClosePAMFilter = () => {
      this.props.app.dm.filterDomain.setState({selectedPamStatus: "", showPAMResetFilterBtn: false})
      this.refreshDataTable();
      return false;
    }

    renderPAMSelectedFilterOpt(isPAMScreen) {
      const { showPAMResetFilterBtn, selectedPamStatus } = this.props.app.dm.filterDomain.state;
      const statusOtp = !!selectedPamStatus && [selectedPamStatus];
      return !!statusOtp && !!statusOtp.length ? (
        <View
          style={[
            commonStyles.flex1,
            commonStyles.flexDirectionRow,
            commonStyles.justifyContentSpaceBetween,
            responsiveTableStyle.filterBySection,
            !!statusOtp && !!statusOtp.length ? responsiveTableStyle.filterBySectionWithFiler : null,
            !!isPAMScreen ? null : commonStyles.displayNone
          ]}>
          <View style={[responsiveTableStyle.filtereHading]}>
            <Text style={[responsiveTableStyle.marB10, commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.fontWeight600]}>Filter by: </Text>
          </View>
          <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexGrow1, commonStyles.flexWrap, commonStyles.alignItemsCenter]}>
            {statusOtp.map((el, ind) => (
              <StatusComponent
                key={ind}
                label={el}
                isSelected={true}
                circleNotAllowed={true}
                hasClose
                marginBottom={[commonStyles.marB0]}
                onCrossClick={() => this.onClosePAMFilter()}
                wrapperStyle={[gridTableStyles.statusWrapperStyle]}
              />
            ))}
          </View>
          {(!!statusOtp && !!statusOtp.length) || selectedPamStatus ? (
            <View tooltip={'Remove All Filters'} style={[commonStyles.marginLeftRight16, commonStyles.marginRight8]}>
                <Touchable onPress={() => this.onClosePAMFilter()} hidden={!showPAMResetFilterBtn}>
                  <View>
                    <Image source={removeFilterIcon} style={commonStyles.icon18} />
                  </View>
                </Touchable>
            </View>
          ) : null
          }
        </View>
      ) : null;
    }

    render() {
      const { name, labelKeys, labelValues, message, searchable, rowControlsRight, autoRefresh = 0, headerControlsRight = null, rowsPerPage = 10, headerTitleTextStyle = null } = this.props;
      const columns = {};
      labelKeys.forEach((keyObj, index) => {
        const key = labelValues[index];
        columns[key] = {
          label: keyObj.label,
          ...(keyObj.sortable !== undefined ? { sortable: keyObj.sortable } : {}),
          ...(keyObj.width !== undefined ? { width: keyObj.width } : {}),
          ...(keyObj.cellStyle ? { cellStyle: keyObj.cellStyle } : {})
        };
      });

      return (
        <SafeAreaView style={[gridTableStyles.screenLayout]}>
          <View style={[responsiveTableStyle.filterBySectionWrapper]}>{this.renderPAMSelectedFilterOpt(true)}</View>
          <DataTable
            name={name}
            columns={columns}
            searchable={searchable}
            initializer={this.initializer}
            rowKeyExtractor={this.rowKeyExtractor}
            pageLoader={this.pageLoader}
            TableEmptyComponent={<NoRecordsFound noRecords={[commonStyles.marLT0, commonStyles.marRT0]} message={message} />}
            cellRenderer={(e) => this.cellRenderer(e)}
            initialPage={1}
            initialRowsPerPage={rowsPerPage}
            initialTotalRows={rowsPerPage}
            initialSortColumnName='type'
            initialSortDirection='asc'
            // onRowPress={(item) => onProfileIcon(item)}
            autoRefresh={autoRefresh}
            headerControlsRight={headerControlsRight}
            headerTitle={this.props.title || null}
            headerTitleTextStyle={[gridTableStyles.headerTitleTextStyle, headerTitleTextStyle]}
            rowControlsRight={!rowControlsRight ? null : (row, dataTable) => {
              return rowControlsRight
            }}
          /> </SafeAreaView>
      );
    }
  }
);